var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgForApproval = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63926 4.88889H5.81963C4.81468 4.88889 4 5.73457 4 6.77778V19.1111C4 20.1543 4.81468 21 5.81963 21H7.63926M8.63926 4.88889V6.77778H14.0982V4.88889M8.63926 4.88889C8.63926 3.84568 9.45394 3 10.4589 3H12.2785C13.2835 3 14.0982 3.84568 14.0982 4.88889M14.0982 4.88889H15.9178C16.9227 4.88889 17.7374 5.73457 17.7374 6.77778V8.66667M12.0195 20.7843L14.009 20.3713C14.1851 20.3347 14.3469 20.2449 14.4739 20.113L20 14.3765L18.1923 12.5L12.6662 18.2365C12.5392 18.3684 12.4526 18.5363 12.4174 18.7191L12.0195 20.7843Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgForApproval);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/for-approval.f656808ab75870bcca9c72538cc2e04d.svg";